import { FormControl, Select, FormHelperText } from '@mui/material'
import { Field } from 'formik'

import { GENDERS } from '@/constants/genders'
import { MaterialUiHelperStyle } from '@/utils/customStyle/helperStyle'
import formatGenders from '@/utils/format/translateGenders'

const Gender = ({ errors, handleChange = () => {}, isDisabled = false }) => {
  return (
    <FormControl error={typeof errors?.gender === 'string'} style={{ width: '100%' }} variant="outlined">
      <MaterialUiHelperStyle />
      <Field
        as={Select}
        data-testid="select-gender"
        disabled={isDisabled}
        name="gender"
        native
        onChange={handleChange}
        style={{
          boxShadow: 'inset 0 0 0 1px $medium-medium',
          height: '48px'
        }}
      >
        <option key="default-gender" value="">
          Gênero
        </option>
        {GENDERS.map((gender) => (
          <option key={gender} value={gender}>
            {formatGenders[gender]}
          </option>
        ))}
      </Field>
      <FormHelperText>{errors?.gender}</FormHelperText>
    </FormControl>
  )
}

export default Gender
